import SelectedFiltersRenderValue from './SelectedFiltersRenderValue.component';

export default SelectedFiltersRenderValue;
